import api from "./api";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getPendingReqCount: async (data) => {
    try {
      const response = await api("requisitions/pending-req-approval", {
        params: data,
      });
      return response.details;
    } catch (error) {
      console.error("Error fetching pending request count:", error);
      throw error;
    }
  },
  getCountPendingPurchaseOrders: async (data) => {
    try {
      const response = await api(
        "purchase_orders/get_pending_purchase_order_count",
        { params: data }
      );
      return response.details;
    } catch (error) {
      console.error("Error fetching pending purchase orders count:", error);
      throw error;
    }
  },
  getCountPendingInvoices: async (data) => {
    try {
      const response = await api(
        "supplier_invoices/get_pending_supplier_invoices",
        { params: data }
      );
      return response.details;
    } catch (error) {
      console.error("Error fetching pending invoices count:", error);
      throw error;
    }
  },
  getCountActiveSuppliers: async (data) => {
    try {
      const response = await api("supplier/count_suppliers_active", {
        params: data,
      });
      return response.details;
    } catch (error) {
      console.error("Error fetching active suppliers count:", error);
      throw error;
    }
  },
  getCountActiveUsers: async (data) => {
    try {
      const response = await api("user/count_active_users", { params: data });
      return response.details;
    } catch (error) {
      console.error("Error fetching active users count:", error);
      throw error;
    }
  },
  getCountAllDepartments: async (data) => {
    try {
      const response = await api("departments/count", { params: data });
      return response.details;
    } catch (error) {
      console.error("Error fetching all departments count:", error);
      throw error;
    }
  },
};
